import {createMultiPathSVG} from './TEMPLATE'

// phosphor: play-fill (fill weight)
export const Play_Filled_Corner0_Rounded = createMultiPathSVG({
  paths: [
    'M240,128a15.74,15.74,0,0,1-7.6,13.51L88.32,229.65a16,16,0,0,1-16.2.3A15.86,15.86,0,0,1,64,216.13V39.87a15.86,15.86,0,0,1,8.12-13.82,16,16,0,0,1,16.2.3L232.4,114.49A15.74,15.74,0,0,1,240,128Z',
  ],
  viewBox: '0 0 256 256',
})

// phosphor: play
export const Play_Stroke2_Corner2_Rounded = createMultiPathSVG({
  paths: [
    'M232.4,114.49,88.32,26.35a16,16,0,0,0-16.2-.3A15.86,15.86,0,0,0,64,39.87V216.13A15.94,15.94,0,0,0,80,232a16.07,16.07,0,0,0,8.36-2.35L232.4,141.51a15.81,15.81,0,0,0,0-27ZM80,215.94V40l143.83,88Z',
  ],
  viewBox: '0 0 256 256',
})
